import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { firebaseAuth } from "../../firebaseConfig";
import { useUserSession } from "../../context/UserContext";
import { useWorkspace } from "../../context/WorkspaceContext";

export const LogoutPage = () => {
  const { setUserSession, revokeUserSession } = useUserSession();
  const { setActiveWorkspace } = useWorkspace();

  useEffect(() => {
    void signOut(firebaseAuth).then(() => {
      setUserSession(undefined);
      setActiveWorkspace(undefined);
      revokeUserSession();
    });
  }, [revokeUserSession, setUserSession, setActiveWorkspace]);

  return <Navigate to="/login" />;
};
